import { VAT_RATE, type Cents } from "../types/money";

/**
 * BTW is anchored on the excl. amount (matches the Timmers webshop to the cent
 * and avoids margin leakage). Storage is always excl. BTW; incl. is derived.
 */
export function addVat(subtotalExcl: Cents, tarief: number = VAT_RATE): { vat: Cents; total: Cents } {
  const vat = Math.round(subtotalExcl * tarief);
  return { vat, total: subtotalExcl + vat };
}

/** Incl.-BTW amount for an excl. amount (display only). */
export function inclFromExcl(excl: Cents): Cents {
  return excl + Math.round(excl * VAT_RATE);
}

/** Excl.-BTW amount for an incl. amount (e.g. article prices entered incl.). */
export function exclFromIncl(incl: Cents): Cents {
  return Math.round(incl / (1 + VAT_RATE));
}
